"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const PagesError404 = () => {
    const navigate = (0, react_router_dom_1.useNavigate)();
    return (react_1.default.createElement("div", { className: "error-page-component" },
        react_1.default.createElement("section", { id: "error-page-section" },
            react_1.default.createElement("div", { className: "container error-page-container" },
                react_1.default.createElement("div", { className: "row error-page-section-row" },
                    react_1.default.createElement("div", { className: "col-lg-6 col-md-12 col-sm-12 error-page-section-col" },
                        react_1.default.createElement("div", { className: "error-page-textual-partial-container" },
                            react_1.default.createElement("h1", { className: "error-page-section-title" }, "Page non trouv\u00E9e"),
                            react_1.default.createElement("div", { className: "error-page-textual-container" },
                                react_1.default.createElement("div", { className: "error-page-textual" },
                                    react_1.default.createElement("p", null, "Oups! Cette page n'existe pas encore.")),
                                react_1.default.createElement("div", { className: "error-page-btn-container" },
                                    react_1.default.createElement("button", { onClick: () => navigate(-1), className: "return-to-homepage-btn btn" }, "Retour"))))),
                    react_1.default.createElement("div", { className: "col-lg-6 col-md-12 col-sm-12 error-page-section-col" },
                        react_1.default.createElement("div", { className: "error-page-code-textual-container" },
                            react_1.default.createElement("h2", { className: "error-page-code" }, "404"))))))));
};
exports.default = PagesError404;
